export default __webpack_public_path__ + "static/media/img2.a693b90f.jpg";